<form [formGroup]="form">
  <div class="quiz-block">
    <div class="answer-block">
      <mat-label>Enter correct answer: </mat-label>
      <mat-form-field>
        <textarea
          matInput
          cols="4"
          rows="6"
          formControlName="freeanswer"
          placeholder="Anwers will vary. Example: (Type Here)"
        ></textarea>
      </mat-form-field>
    </div>
  </div>
</form>
